import isMedicoExterno from '../../util/medicoHelpers';

// TODO: Permissoes devem vir do backend
const allowedToDelete = (medico, funcionario, laudo) => {
  if (isMedicoExterno(medico)) return false;

  switch (laudo) {
    case 'AGENDA':
      return funcionario?.codFunc === '90001';

    case 'PRONTUARIO':
      return medico;

    case 'TODOS':
      return (
        medico ||
        funcionario?.codFunc === '90026' || // CAROL
        funcionario?.codFunc === '90001' || // ALESSANDRA
        funcionario?.codFunc === '90032' || // MARINA
        funcionario?.codFunc === '90038' || // GIOVANA
        funcionario?.codFunc === '90009' // ISABELA
      );

    default:
      return medico;
  }
};

export default allowedToDelete;
